import React, { Component } from "react";

import ModalConditions from "../modal/modal_conditions";

class MoreInfo extends Component {
  state = { openModal: false };
  render() {
    if (!this.props.list.give_away) {
      return <div />;
    }
    if (this.props.list.give_away.more_info === "") {
      return <div />;
    }
    return (
      <React.Fragment>
        <label
          style={{
            textTransform: "capitalize",
            fontFamily: "DIN Pro Bold",
            fontSize: "16px"
          }}
          className="name cursor_btn pt-2"
          onClick={this.openningModal}
        >
          <ion-icon class="ion-icon" name="information-circle-outline" /> More
          Info
        </label>
        <ModalConditions
          open={this.state.openModal}
          text={this.props.list.give_away.more_info}
          handleCloseView={this.handleCloseView}
        />
      </React.Fragment>
    );
  }

  openningModal = event => {
    event.preventDefault();
    this.setState({ openModal: true });
  };

  handleCloseView = e => {
    this.setState({ openModal: false });
  };
}

export default MoreInfo;



// WEBPACK FOOTER //
// ./src/components/list/interface/winner/more_info.jsx